import React from 'react';
// ============================================
// VARIANT IDs — edit these to update products
// ============================================
const MAIN_PRODUCT_VARIANT_ID = '44791649009750';
const UPSELL_PRODUCT_VARIANT_ID = '44798137401430';
const SHOPIFY_CART_BASE = 'https://impulsodigital.vip/cart/';
// ============================================
import { CheckoutProvider } from './components/CheckoutContext';
import { StickyCTA } from './components/StickyCTA';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismShift } from './components/MechanismShift';
import { OfferBox } from './components/OfferBox';
import { BonusesSection } from './components/BonusesSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <CheckoutProvider mainVariantId={MAIN_PRODUCT_VARIANT_ID} upsellVariantId={UPSELL_PRODUCT_VARIANT_ID} cartBaseUrl={SHOPIFY_CART_BASE} data-id="element-0">
      <div className="min-h-screen bg-brand-black text-brand-white pb-24" data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <MechanismShift data-id="element-4" />
        <OfferBox data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <Footer data-id="element-12" />
        <StickyCTA data-id="element-13" />
      </div>
    </CheckoutProvider>;
}